<template>
    <div class="my-apps">
        <template v-for="list in getMyAppPlugins" >
            <component  v-if="evaluatePluginCondition(list)" :key="list.id" :is="list.component" v-bind="{from:'MyApps'}"></component>
        </template> 
        <template v-if="getMyAppPlugins.length == 0 || getMyAppPlugins.every(x=>evaluatePluginCondition(x)==false)">
            <div class="connect-container">
                <div class="connect-message">
                    <h6 style="color: #757575" class="m-0 text-left">{{$t('No apps available')}}</h6>
                </div>
            </div>
        </template>  
    </div>
</template>
<script>
import { mapGetters,mapMutations } from "vuex";
import Utils from "../../components.utils.js";

export default {
    name: 'MyApps',
    data() {
        return {
            // Define your data properties here
        };
    },
    computed:{
        ...mapGetters("registry",["getMyAppPlugins"]),
        ...mapGetters('pluginRepo',["getInstalledPluginsData"]),
        ...mapGetters("users", ["getLoggedInUserPrivilege"]),
    },
    async created() {
        for(let i = 0; i < this.getMyAppPlugins.length; i++){
          if(!Object.prototype.hasOwnProperty.call(this.getMyAppPlugins[i],'component')){
             console.log(`this.getMyAppPlugins[i]`,this.getMyAppPlugins[i],'[this.getMyAppPlugins[i].pluginBundle.js]',[this.getMyAppPlugins[i].pluginBundle.js]);
             let compInfo = await  Utils.loadPluginBundles([this.getMyAppPlugins[i].pluginBundle.js],this.getMyAppPlugins[i].componentLoadedEventName);
             console.log("............compInfo",compInfo);
             if(compInfo && Array.isArray(compInfo) && compInfo.length){
                if('register' in this.getMyAppPlugins[i]){
                  this.getMyAppPlugins[i].register();
                }
                const ev = new Event('register-routes');
                if('pluginStore'  in compInfo[0]){
                    ev.pluginStore = compInfo.pluginStore;
                }
                parent.document.body.dispatchEvent(ev);
                Utils.loadCssBundle(this.getMyAppPlugins[i].pluginBundle.css);
                this.updateMyApps({id:this.getMyAppPlugins[i].id,data:{component:compInfo[0].components}});
             }
          }
      }
    },
    methods: {
        ...mapMutations("registry",["updateMyApps"]),
        evaluatePluginCondition(list){
            return list.evalCondition(this);
        },
        isPluginInstalled(pluginName){
            if(this.getInstalledPluginsData){
                let indx = this.getInstalledPluginsData.findIndex(e => e.plugin_name.toLowerCase() == pluginName.toLowerCase())
                if(indx > -1){
                    return true;
                }
            }
            return false;
        },
        isEnabled(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },
    },
    mounted() {
        // Code to run when the component is mounted
    }
};
</script>
<style scoped lang="scss">
.my-apps{
    cursor: auto;
    height: 100%;
}
.connect-container{
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    width: 100%;
    height: 50vh;
}
.connect-message{
    display: flex; 
    align-items: center; 
    gap: 12px; 
    padding-top: 2%;
}
</style>